import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import HighlightedMerchCard from './HighlightedMerchCard';
import { borderStyle, StyledCardGrid } from './MerchCardSharedComponents';
import { getMerchCardsToShow } from '../../constants/merchCards/MerchCardsToShow';
import { FREE, STARTER } from 'self-service-api/constants/ProductLevels';
import HighlightedFreeCard from './HighlightedFreeCard';
import { useSelector } from 'react-redux';
import { ENTERPRISE } from '../../constants/routing/Tabs';
import Screens from '../../constants/routing/Screens';
import { isStarterGWP2023EligibleSelector } from '../../selectors/PromotionSelectors';
import { CMS } from 'self-service-api/constants/ProductLines';
import StarterCrmSuiteCardCBX003 from '../cbx003/StarterCrmSuiteCardCBX003';
import StarterCrmSuiteCtaCardGWP from '../product-pages/StarterCrmSuiteCtaCardGWP';
import { useIsCBX003Variant } from '../../hooks/cbx003Hooks';

const HubTierInfo = ({
  productLine,
  selectedTab
}) => {
  const isCBX003Variant = useIsCBX003Variant();
  const isStarterGWP = useSelector(isStarterGWP2023EligibleSelector);
  const productLevels = getMerchCardsToShow({
    tab: selectedTab
  });
  const shouldDisplaySuiteCard = isStarterGWP && selectedTab !== ENTERPRISE;
  const merchCardComponents = productLevels.map((productLevel, index) => {
    const commonStyles = {
      msGridColumn: index + 1,
      // IE
      gridColumnStart: index + 1,
      paddingLeft: 28,
      paddingRight: 28,
      borderRight: borderStyle,
      borderLeft: borderStyle
    };

    if (FREE === productLevel) {
      return /*#__PURE__*/_jsx(HighlightedFreeCard, {
        productLine: productLine,
        commonStyles: commonStyles,
        perMonth: false
      }, `${productLine}-${productLevel}`);
    }

    const disclaimer = productLevel === STARTER && isStarterGWP && productLine !== CMS ? 'pricingPage.promotions.starterGWPDisclaimer' : undefined;
    return /*#__PURE__*/_jsx(HighlightedMerchCard, {
      productLevel: productLevel,
      productLine: productLine,
      commonStyles: commonStyles,
      selectedTab: selectedTab,
      disclaimer: disclaimer
    }, `${productLine}-${productLevel}`);
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-column align-center justify-center",
    style: {
      width: '100%'
    },
    children: [shouldDisplaySuiteCard && (isCBX003Variant ? /*#__PURE__*/_jsx(StarterCrmSuiteCardCBX003, {
      screen: Screens[productLine]
    }) : /*#__PURE__*/_jsx(StarterCrmSuiteCtaCardGWP, {
      screen: Screens[productLine]
    })), /*#__PURE__*/_jsx(StyledCardGrid, {
      columns: productLevels.length,
      children: merchCardComponents
    })]
  });
};

export default HubTierInfo;